import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
// import store from '../store'
// import { getToken } from '@/utils/auth'
import qs from 'qs'

let baseUrl = 'https://www.westbeach.top/serve';
// let baseUrl = 'http://localhost:9245'
// let baseUrl = process.env.VUE_APP_BASE_API || 'https://msz-api.ynoudun.com';

// 创建axios实例
let service = axios.create({
	baseURL: baseUrl, // api的base_url
	timeout: 5000 // 请求超时时间
});
// request拦截器
service.interceptors.request.use(config => {
	// if (store.getters.token) {
	// 	config.headers['Authorization'] = getToken('Token')
	// }
	return config
}, error => {
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
		const res = response.data
		if(res.intent && res.intent.code == 0){
			return response.data.results
		}else if(res.code == 200){
			return response.data
		}else{
			Message({message: res.message,type: 'error', duration: 5 * 1000})
			return Promise.reject('error')
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)



const defaultErrorCallback = (error) => {
}

export const serverData = {
	baseUrl
}

export const getJson = (url, params, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		url,
		method: 'get',
		params
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const postJson = (url, data = {}, callback = () => {}) => {
	service.request({
		url,
		method: 'post',
		data
	}).then(res => {
		callback(res)
	})
}

export const postForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url,
		method: 'post',
		data
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const putForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		url,
		method: 'put',
		data: qs.stringify(data)
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const patchForm = (url, data = {}, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		url,
		method: 'patch',
		data: qs.stringify(data)
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const deleteJson = (url, params, callback = () => {}, errcallback = defaultErrorCallback) => {
	service.request({
		url,
		method: 'delete',
		params
	}).then(res => {
		callback(res)
	}).catch(res => {
		errcallback(res)
	})
}

export const deleteJsonSYNC = (url, params) => {
	return service.request({
		url,
		method: 'delete',
		params
	})
}

export default service
